import { render, staticRenderFns } from "./OpenInNewIcon.vue?vue&type=template&id=c5a825e0&scoped=true&"
import script from "./OpenInNewIcon.vue?vue&type=script&lang=js&"
export * from "./OpenInNewIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a825e0",
  null
  
)

export default component.exports